import ApiService from "@/services/api.service";

const state = {
  users: [],
};
const getters = {
  getUsers(state) {
    return state.users;
  },
};
const actions = {
  fetchUsers({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("getusers/", payload)
        .then(({ data }) => {
          commit("setUsers", data.result);
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  createUser({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("createuser/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  updateUser({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("updateuser/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
  deleteUser({ commit }, payload) {
    return new Promise((resolve) => {
      ApiService.post("deleteuser/", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          commit("HANDLE_ERROR", e, {
            root: true,
          });
        });
    });
  },
};
const mutations = {
  setUsers(state, payload) {
    state.users = payload;
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
